export const countryPhoneCodes = [
    // Afrique
    { country: "Côte d'Ivoire", code: "+225" },
    { country: "Nigeria", code: "+234" },
    { country: "Ghana", code: "+233" },
    { country: "Kenya", code: "+254" },
    { country: "Ethiopia", code: "+251" },
    { country: "South Africa", code: "+27" },
    { country: "Tanzania", code: "+255" },
    { country: "Uganda", code: "+256" },
    { country: "Algeria", code: "+213" },
    { country: "Morocco", code: "+212" },
    
    // Europe
    { country: "France", code: "+33" },
    { country: "Germany", code: "+49" },
    { country: "Spain", code: "+34" },
    { country: "Italy", code: "+39" },
    { country: "United Kingdom", code: "+44" },
    { country: "Netherlands", code: "+31" },
    { country: "Belgium", code: "+32" },
    { country: "Sweden", code: "+46" },
    { country: "Norway", code: "+47" },
    { country: "Denmark", code: "+45" },
    
    // Amérique
    { country: "United States", code: "+1" },
    { country: "Canada", code: "+1" },
    { country: "Mexico", code: "+52" },
    { country: "Brazil", code: "+55" },
    { country: "Argentina", code: "+54" },
    { country: "Colombia", code: "+57" },
    { country: "Chile", code: "+56" },
    { country: "Peru", code: "+51" },
    { country: "Venezuela", code: "+58" },
    { country: "Cuba", code: "+53" },
    { country: "Panama", code: "+507" },
    { country: "Costa Rica", code: "+506" },
    { country: "Jamaica", code: "+1-876" },
    { country: "Honduras", code: "+504" },
    { country: "Guatemala", code: "+502" },
    { country: "Ecuador", code: "+593" },
    { country: "Bolivia", code: "+591" },
    { country: "Paraguay", code: "+595" },
    { country: "Uruguay", code: "+598" },
    { country: "El Salvador", code: "+503" },
    
    // Asie
    { country: "China", code: "+86" },
    { country: "India", code: "+91" },
    { country: "Japan", code: "+81" },
    { country: "South Korea", code: "+82" },
    { country: "Indonesia", code: "+62" },
    { country: "Pakistan", code: "+92" },
    { country: "Bangladesh", code: "+880" },
    { country: "Philippines", code: "+63" },
    { country: "Vietnam", code: "+84" },
    { country: "Turkey", code: "+90" },
    { country: "Iran", code: "+98" },
    { country: "Thailand", code: "+66" },
    { country: "Myanmar", code: "+95" },
    { country: "Saudi Arabia", code: "+966" },
    { country: "Malaysia", code: "+60" },
    { country: "Sri Lanka", code: "+94" },
    { country: "Kazakhstan", code: "+7" },
    { country: "Iraq", code: "+964" },
    { country: "Afghanistan", code: "+93" },
    { country: "Nepal", code: "+977" }
  ];
  
  console.log(countryPhoneCodes);
  